import React, { FunctionComponent, useEffect, useState } from "react";

import { Button, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import cls from 'classnames';

import {
  selectAreCoursesFetching,
} from "../../features/courses/coursesSlice";
import { MainLayout } from "../common/Layouts/Main";
import { UserForm } from "./Form";
import { Prefixes } from "../prefixes";
import { disableUsersStatus, enableUsersStatus, hideModalForReset, isResettingUser, resetUser, selectDisplayModalForReset, UserRole } from "../../features/users/usersSlice";
import { selectUserByUsername } from "../../features/users/userSlice";
import { getTranslations } from "../../features/translations/translationsUtils";
import { fetchCompany, selectCompany } from "../../features/company/companySlice";
import { DialogPopUpConfirmation } from "../common/DialogPopUpConfirmation";
import { DialogPopUp } from "../common/DialogPopUp";
import { getCognitoUserData } from "../../features/auth/authSlice";

export const EditUser: FunctionComponent = () => {
  const cognitoUserData = useSelector(getCognitoUserData);
  const role = cognitoUserData ? cognitoUserData["custom:role"] : undefined;
  const isSuperAdmin = role === UserRole.SuperAdmin;
  const match = useRouteMatch();
  const areCoursesFetching = useSelector(selectAreCoursesFetching);
  const [form] = Form.useForm();
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [resetConfirmationOpen, setResetConfirmationOpen] = useState(false);
  const resettingUser = useSelector(isResettingUser);
  const isModalVisible = useSelector(selectDisplayModalForReset);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!areCoursesFetching) {
      form.setFieldsValue({});
      form.resetFields();
    }
  }, [form, areCoursesFetching]);
  const userId = (match.params as any).id;
  const editing = (match.params as any).id!;
  const userToEdit = useSelector(selectUserByUsername);
  const company = useSelector(selectCompany(userToEdit?.company ?? ''));

  useEffect(() => {
    if (userToEdit?.company) {
      dispatch(fetchCompany(userToEdit.company));
    }
  }, [dispatch, userToEdit?.company]);

  useEffect(() => {
    if (isModalVisible) {
      setResetConfirmationOpen(false);
    }
  }, [isModalVisible]);

  const goToPrint = () => {
    history.push(`/admin-users/${editing}/print`);
  };

  const enableStatus = () => {
    const data = {
      usernames: [editing],
    };
    dispatch(enableUsersStatus(true, data));
    setEnabled(!enabled);
  };

  const disableStatus = () => {
    const data = {
      usernames: [editing],
    };
    dispatch(disableUsersStatus(true, data));
    setEnabled(!enabled);
  };
  const resetUserConfirmation = () => {
    setResetConfirmationOpen(true);
  }
  const renderOptions = () => {
    const isEnabled = userToEdit?.enabled ?? false;
    return <>
      <DialogPopUp
        name={getTranslations('USERS_TITLE_SINGULAR')}
        action={getTranslations('USERS_RESTARTED')}
        visible={isModalVisible}
        onCancel={() => {
          dispatch(hideModalForReset());
        }}
      />
      <DialogPopUpConfirmation
        name={getTranslations('USERS_RESET_ACTION')}
        visible={resetConfirmationOpen}
        onCancel={() => {
          setResetConfirmationOpen(false);
        }}
        cancelText={getTranslations('USERS_RESET_ACTION_CANCEL')}
        okText={getTranslations('USERS_RESET_ACTION_OK')}
        onOk={() => {
          dispatch(resetUser(userId))
        }}
        loading={resettingUser}
      />
      {isSuperAdmin ? <><Button
        type="link"
        size="large"
        className={cls({ withBorder: !isEnabled })}
        onClick={resetUserConfirmation}
        disabled={isEnabled}
      >
        {getTranslations('USERS_RESET')}
      </Button>&nbsp;&nbsp;&nbsp;</> : null}
      <Button
        type="link"
        size="large"
        onClick={!enabled ? enableStatus : disableStatus}
      >
        {!enabled ? getTranslations('LIST_ENABLE') : getTranslations('LIST_DISABLE')}
      </Button>&nbsp;&nbsp;&nbsp;
      <Button
        type="link"
        size="large"
        onClick={goToPrint}
        className="withBorder"
      >
        {getTranslations('USERS_DOWNLOAD_FILE')}
      </Button>&nbsp;&nbsp;&nbsp;
      {company?.showInfographic ? <Button
        type="primary"
        size="large"
        onClick={() => {
          history.push(`/users/${editing}/infographic`);
        }}
      >
        {getTranslations('USERS_VIEW_INFOGRAPHIC')}
      </Button> : null}
    </>;
  }
  return (
    <MainLayout
      hideTitle={false}
      title={title}
      onGoBack={() => {
        history.push(`${Prefixes.user}`);
      }}
      breadcrumbs={[getTranslations('USERS_TITLE'), title]}
      rightTopOptions={renderOptions()}
    >
      <UserForm
        editing={editing}
        form={form}
        setTitle={setTitle}
        setEnabled={setEnabled}
      />
    </MainLayout>
  );
};
